import { useState } from 'react';
import { Link } from '../components/ui/Link';
import { Title } from '../components/ui/Title';
import { ScoreExportDialog } from '../components/admin/ScoreExportDialog';
import { ImportDialog } from '../components/admin/ImportDialog';
import { ManagementReportDialog } from '../components/admin/ManagementReportDialog';

export enum ModalType {
    IMPORT = 'IMPORT',
    SCORE_EXPORT = 'SCORE_EXPORT',
    REPORT = 'REPORT',
}

export const CockpitPage = () => {
    const [openModal, setOpenModal] = useState<ModalType | null>();

    const toggleModal = (e: any, modalType: ModalType) => {
        e.preventDefault();

        setOpenModal((current) => (current === modalType ? undefined : modalType));
    };

    return (
        <>
            <div className="flex flex-col gap-6 md:gap-12">
                <div className="py-3 md:py-0 flex justify-between items-center">
                    <Title>Cockpit</Title>
                </div>

                <div className="flex flex-col gap-6 items-start">
                    <Link href="#" onClick={(e) => toggleModal(e, ModalType.IMPORT)}>
                        Importeren tankbeurten
                    </Link>
                    <Link href="#" onClick={(e) => toggleModal(e, ModalType.SCORE_EXPORT)}>
                        Score export
                    </Link>
                    <Link href="#" onClick={(e) => toggleModal(e, ModalType.REPORT)}>
                        Management rapportage
                    </Link>
                </div>
            </div>

            {openModal === ModalType.SCORE_EXPORT && (
                <ScoreExportDialog open={openModal === ModalType.SCORE_EXPORT} setOpenModal={setOpenModal} />
            )}

            {openModal === ModalType.IMPORT && (
                <ImportDialog open={openModal === ModalType.IMPORT} setOpenModal={setOpenModal} />
            )}

            {openModal === ModalType.REPORT && (
                <ManagementReportDialog open={openModal === ModalType.REPORT} setOpenModal={setOpenModal} />
            )}
        </>
    );
};
